import { xhrPutBlob } from 'src/lib/pricelist-utils';
import type {
  PresignedUploadUrlInput,
  PresignedUploadUrlResponse,
} from '@erp/rpc';

/**
 * Stage one file in blob storage through a presigned URL and return the key
 * the server minted for it.
 *
 * `getUploadUrl` reserves the URL, the file is PUT there raw (an XHR, so the
 * upload has a percentage), and the key is what a confirm or start procedure
 * is then given. Nothing binary passes through the API server. Shared by the
 * pricing uploads (masterlist, agreement extract, Hubbell Feedback), which
 * differ only in the procedure that mints the URL and what claims the key.
 */
export async function stageUpload(input: {
  file: File;
  contentType: string;
  getUploadUrl: (
    input: PresignedUploadUrlInput,
  ) => Promise<PresignedUploadUrlResponse>;
  onUploadProgress?: (percent: number) => void;
}): Promise<string> {
  const { file, contentType } = input;
  const { uploadKey, uploadUrl } = await input.getUploadUrl({
    fileName: file.name,
    contentType,
    fileSizeBytes: file.size,
  });
  await xhrPutBlob({
    url: uploadUrl,
    body: file,
    contentType,
    onUploadProgress: (percent) => input.onUploadProgress?.(percent),
  });
  return uploadKey;
}
